import React from "react";

/**
 * Google Analytics 4 mark: three rising bars, amber for the tallest and a
 * darker orange for the other two.
 */
export const GoogleAnalyticsIcon = ({ size = 20, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      {...props}
    >
      <rect x="14.6" y="2" width="5.4" height="20" rx="2.7" fill="#F9AB00" />
      <rect x="7.6" y="9" width="5.4" height="13" rx="2.7" fill="#E37400" />
      <circle cx="3.7" cy="19.3" r="2.7" fill="#E37400" />
    </svg>
  );
};

export default GoogleAnalyticsIcon;
